<template>
  <div class="PopupWrapper" :style="{width:windowWidth+'px',height:windowHeight+'px',lineHeight:windowHeight+'px'}" @click.stop="closePopup">
    <div class="Popup" @click.stop="()=>{}">
      <div class="popupHeader">
        <span>{{title}}</span>
        <span class="closeBtn" @click="closePopup"><i class="el-icon-close" /></span>
      </div>
      <div class="popupBody">
        <slot name="popupContent"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import {getClientSize} from '../util/util';

export default {
  name: 'Popup',
  props:{
    title:{
      type:String,
      default:'提示信息'
    },
  },
  data(){
    return{
      show:false,
      windowWidth:getClientSize().width,
      windowHeight:getClientSize().height,
    }
  },
  methods:{
    closePopup(){
      this.$emit('popupClose');
    }
  },
}
</script>

<style scoped lang="less">
@import "../assets/css/var.less";

.PopupWrapper{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2000;
  background-color: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(2px);
  text-align: center;

  .Popup{
    display: inline-block;
    vertical-align: middle;
    line-height: normal;
    background: #ffffff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);
    border: 1px solid #e2e8f0;
    text-align: left;

    .popupHeader{
      height: 48px;
      line-height: 48px;
      background-color: #f8fafc;
      border-bottom: 1px solid #e2e8f0;
      padding: 0 20px;
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;

      span{
        font-size: 15px;
        font-weight: 700;
        color: #0f172a;
      }

      .closeBtn{
        cursor: pointer;
        color: #94a3b8;
        font-size: 16px;
        transition: color 0.2s ease;

        &:hover{
          color: #ef4444;
        }
      }
    }

    .popupBody{
      background-color: #ffffff;
      padding: 20px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Popup.vue